import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _get from "lodash/get";

var _createReducer;

import { createReducer } from 'redux-act';
import { unsubscribe, signin, createTUCustomer, enrollTUCustomer } from "../actions";

var setFlag = function setFlag(name, val) {
  return function (state) {
    return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, name, val));
  };
};

export default createReducer((_createReducer = {}, _defineProperty(_createReducer, unsubscribe.success, setFlag('unsubscribeSuccess', true)), _defineProperty(_createReducer, unsubscribe.fail, setFlag('unsubscribeSuccess', false)), _defineProperty(_createReducer, signin.fail, function (state, payload) {
  var isBlocked = payload.isBlocked,
      signinAttemptsRemaining = payload.signinAttemptsRemaining;
  return _objectSpread(_objectSpread({}, state), {}, {
    isSigninBlocked: isBlocked,
    signinAttemptsRemaining: signinAttemptsRemaining
  });
}), _defineProperty(_createReducer, enrollTUCustomer.fail, setFlag('enrollFailed', true)), _defineProperty(_createReducer, createTUCustomer.fail, function (state, payload) {
  if (_get(payload, 'internal_message') === 'User has attempted authentication too many times') {
    return _objectSpread(_objectSpread({}, state), {}, {
      createTURateLimited: true
    });
  }

  return state;
}), _createReducer), {});